"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const normalizeGetCreditLimit = ({ response, userPq = {} }) => {
    let res = null;
    let userRecom = {};
    if (response) {
        res = {};
        /* -------------------------- montamos estructuras -------------------------- */
        // Credit Limit
        if (response.clientInfo && response.clientInfo.creditLimit) {
            res.creditLimit = {
                tpvp: response.clientInfo.creditLimit.totalPVP,
                mpvp: response.clientInfo.creditLimit.monthlyPVP,
            };
        }
        // Recom
        if (response.recommendation) {
            const data = response.recommendation;
            userRecom = {
                fidelizacion: {
                    recomendaciones: [...data.fidelizacion]
                }
            };
            if (data.comercial && data.comercial.verticales) {
                const { verticales } = data.comercial;
                if (Object.keys(verticales) && Object.keys(verticales).length > 0) {
                    Object.keys(verticales).forEach(vertical => {
                        userRecom[vertical] = verticales[vertical];
                    });
                }
            }
        }
    }
    let finalUserPq = Object.assign(Object.assign({}, userPq), res);
    // comprobaciones de datos
    if (finalUserPq.mpvp <= 3 && finalUserPq.clt === 5) {
        if (finalUserPq.halmsm) {
            finalUserPq.f = true;
        }
        finalUserPq.clt = 3;
    }
    return {
        userPq: finalUserPq,
        userRecom
    };
};
exports.default = normalizeGetCreditLimit;
//# sourceMappingURL=index.js.map